function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { AnalyticsProvider } from '../../providers/AnalyticsProvider.js';
import '../../ui/Div/index.js';
import { ErrorBoundary } from '../../ui/ErrorBoundary.js';
import { Banner } from './Banner.js';
import { MainNavbar } from './MainNavbar.js';
import './SubNav/index.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from '../../ui/Div/Div.js';
import { SubNav } from './SubNav/SubNav.js';
function GlobalNavbar({
  primaryLogoTitle,
  primaryLogoHref,
  primaryLogoImageUrl,
  navLinks,
  secondaryCtaLabel,
  secondaryCtaUrl,
  primaryCtaLabel,
  primaryCtaUrl,
  subnav,
  banner,
  style = 'default',
  secondaryLogo,
  secondaryLogoHref,
  showSecondaryLogoOnMobile = false,
  regionDropdownCTA,
  customSignInCTA,
  contactUsUrl,
  contactUsText,
  customLogoHeight
}) {
  const _ref = banner || {},
    label = _ref.label,
    bannerUrl = _ref.url;
  const hasSubnav = subnav?.productName && subnav?.productUrl || subnav?.subNavLinks?.length || subnav?.hasSearch;
  return /*#__PURE__*/jsx(ErrorBoundary, {
    children: /*#__PURE__*/jsx(AnalyticsProvider, {
      analyticsPrefix: "GlobalNavbar",
      children: /*#__PURE__*/jsxs(Div, {
        as: "header",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        position: "sticky",
        zIndex: 10,
        width: "100%",
        top: 0,
        css: {
          pointerEvents: 'none',
          nav: {
            pointerEvents: 'all'
          }
        },
        children: [label && /*#__PURE__*/jsx(Banner, {
          label: label,
          url: bannerUrl
        }), /*#__PURE__*/jsx(MainNavbar, {
          hasBanner: !!label,
          primaryLogoTitle: primaryLogoTitle,
          primaryLogoHref: primaryLogoHref,
          primaryLogoImageUrl: primaryLogoImageUrl,
          navLinks: navLinks,
          secondaryCtaLabel: secondaryCtaLabel,
          secondaryCtaUrl: secondaryCtaUrl,
          primaryCtaLabel: primaryCtaLabel,
          primaryCtaUrl: primaryCtaUrl,
          style: style,
          secondaryLogo: secondaryLogo,
          secondaryLogoHref: secondaryLogoHref,
          showSecondaryLogoOnMobile: showSecondaryLogoOnMobile,
          regionDropdownCTA: regionDropdownCTA,
          customSignInCTA: customSignInCTA,
          contactUsUrl: contactUsUrl,
          contactUsText: contactUsText,
          customLogoHeight: customLogoHeight
        }), hasSubnav && /*#__PURE__*/jsx(SubNav, _objectSpread(_objectSpread({}, subnav), {}, {
          hasBanner: !!label,
          style: style
        }))]
      })
    })
  });
}
export { GlobalNavbar };
//# sourceMappingURL=GlobalNavbar.js.map
